<template>
  <div>
    <pbas-data-table
      ref="table"
      :dataProvider="provider"
      :rowActions="rowActions"
      :floatActions="floatActions"
      :selectActions="selectActions"
      :exporters="$exporters"
      @itemsChanged="setData($event)"
      @error="error = $event"
    ></pbas-data-table>

    <item-edit
      :item="editItem"
      @cancel="editItem = null"
      @update:item="
        editItem = null;
        $refs.table.getDataAsync();
      "
      :allCategories="categories"
      @reload-categories="$emit('reload-categories')"
    ></item-edit>
    <v-dialog v-model="showAssignments" scrollable max-width="700">
      <item-coverage-assignments
        :showCancel="true"
        @cancel="showAssignments = false"
        @saved="
          showAssignments = false;
          $refs.table.getDataAsync();
        "
        :item="item"
      ></item-coverage-assignments>
    </v-dialog>
    <error-handler :error="error" />
  </div>
</template>

<script>
import CoverageItemsHeaders from "../../headers/CoverageItems";
import { ODataProvider } from "pbas-vue-components";
import { mapActions, mapGetters } from "vuex";
import ItemEdit from "./ItemEdit";
import ItemCoverageAssignments from "./ItemCoverageAssignments";
import ErrorHandler from "../../components/ErrorHandler";
import { ODataHeader, ODataString } from "pbas-vue-components";
import { translate2 } from "../../trans2";

export default {
  components: { ItemEdit, ErrorHandler, ItemCoverageAssignments },
  props: {
    categories: Array,
  },
  data: function() {
    return {
      item: null,
      editItem: null,
      provider: undefined,
      headers: CoverageItemsHeaders,
      error: null,
      showAssignments: false,
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.edit(item),
        },
        {
          name: "assignCoverage",
          icon: "assignment_turned_in",
          title: "globals.assign",
          handler: (item) => {
            this.assignCoverage(item);
          },
        },
        {
          name: "remove",
          icon: "delete",
          title: "globals.remove",
          handler: (item) => this.remove(item),
        },
      ],
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.edit({
              PlanId: this.selectedPlan.Id,
              CoverageTileItemCoverageTiles: [],
              JsonCoverageIds: null,
            });
          },
        },
      ],
      selectActions: [
        {
          name: "delete",
          icon: "delete",
          title: "globals.remove",
          handler: (items) => {
            items.forEach((i) => this.remove(i));
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
  },
  watch: {
    categories: {
      handler(v) {
        // this.$refs.table.getDataAsync();
      },
    },
  },
  async mounted() {
    let allCoverage = (await this.getCoverageIdentities({
      plan: this.selectedPlan.Id,
    })).value;
    this.provider = new ODataProvider(
      this.$axiosHttp,
      this.settings.APIURL +
        "cms/odata/plans/" +
        this.selectedPlan.Id +
        "/CoverageTileItems",
      this.headers.concat([
        new ODataHeader({
          title: "globals.coverage",
          type: new ODataString("JsonCoverageIds", {
            getString: (item) => {
              let cov = JSON.parse(item.JsonCoverageIds);
              let itemCov = allCoverage.filter((o) => {
                return cov && cov.filter((c) => c === o.Id).length > 0;
              });
              return itemCov
                .map((o) => translate2(o.Current, "Name"))
                .join(", ");
            },
          }),
          visible: true,
          allowVisibilityChange: true,
          searchable: true,
          sortable: false,
        }),
      ])
    );
  },
  methods: {
    ...mapActions("downloadCenter", ["deleteCoverageTileItem"]),
    ...mapActions("plansMembers", ["getCoverageIdentities"]),
    setData(items) {
      this.$emit("items-changed", items);
    },
    reload() {
      this.$refs.table.getDataAsync();
    },
    edit(item) {
      this.editItem = item;
    },
    assignCoverage(item) {
      this.item = item;
      this.showAssignments = true;
    },
    async remove(item) {
      try {
        await this.deleteCoverageTileItem(item);
        this.$refs.table.getDataAsync();
      } catch (e) {
        this.error = e;
      }
    },
  },
};
</script>
